const dataSource = {
  "CLA-J": [
    {
      "fr_de_eu": "27",
      "it": "26",
      "uk": "C9",
      "us_woman": "K10",
      "us_man": "K10",
    },
    {
      "fr_de_eu": "28",
      "it": "27",
      "uk": "C10",
      "us_woman": "K11",
      "us_man": "K11",
    },
    {
      "fr_de_eu": "29",
      "it": "28",
      "uk": "C11",
      "us_woman": "K12",
      "us_man": "K12",
    },
    {
      "fr_de_eu": "30",
      "it": "29",
      "uk": "C11 2/3",
      "us_woman": "K12.5",
      "us_man": "K12.5",
    },
    {
      "fr_de_eu": "31",
      "it": "30",
      "uk": "C12 1/3",
      "us_woman": "K13 1/3",
      "us_man": "K13 1/3",
    },
    {
      "fr_de_eu": "32",
      "it": "31",
      "uk": "C13",
      "us_woman": "1",
      "us_man": "1",
    },
    {
      "fr_de_eu": "33",
      "it": "32",
      "uk": "1",
      "us_woman": "2",
      "us_man": "2",
    },
    {
      "fr_de_eu": "34",
      "it": "33",
      "uk": "2",
      "us_woman": "3",
      "us_man": "3",
    },
    {
      "fr_de_eu": "35",
      "it": "34",
      "uk": "2.5",
      "us_woman": "4",
      "us_man": "4",
    },
    {
      "fr_de_eu": "36",
      "it": "35",
      "uk": "3.5",
      "us_woman": "5",
      "us_man": "-",
    },
    {
      "fr_de_eu": "37",
      "it": "36",
      "uk": "4.5",
      "us_woman": "6",
      "us_man": "-",
    },
    {
      "fr_de_eu": "38",
      "it": "37",
      "uk": "5",
      "us_woman": "7",
      "us_man": "-",
    },
    {
      "fr_de_eu": "39",
      "it": "38",
      "uk": "5.5",
      "us_woman": "8",
      "us_man": "6",
    },
    {
      "fr_de_eu": "40",
      "it": "39",
      "uk": "6.5",
      "us_woman": "9",
      "us_man": "7",
    },
    {
      "fr_de_eu": "41",
      "it": "40",
      "uk": "7",
      "us_woman": "10",
      "us_man": "8",
    },
    {
      "fr_de_eu": "42",
      "it": "41",
      "uk": "8",
      "us_woman": "11",
      "us_man": "9",
    },
    {
      "fr_de_eu": "43",
      "it": "42",
      "uk": "9",
      "us_woman": "12",
      "us_man": "10",
    },
    {
      "fr_de_eu": "44",
      "it": "43",
      "uk": "10",
      "us_woman": "13",
      "us_man": "11",
    },
    {
      "fr_de_eu": "45",
      "it": "44",
      "uk": "10",
      "us_woman": "-",
      "us_man": "12",
    },
    {
      "fr_de_eu": "46",
      "it": "45",
      "uk": "11",
      "us_woman": "-",
      "us_man": "13",
    },
  ],
  "CLA-CA": {
    "150-155": {
      45: "S",
      50: "S",
      55: "",
      60: "",
      65: "",
      70: "",
      75: "",
      80: "",
    },
    "155-160": {
      45: "S",
      50: "S",
      55: "S",
      60: "M",
      65: "M",
      70: "L",
      75: "",
      80: "",
    },
    "160-165": {
      45: "S",
      50: "S",
      55: "S",
      60: "M",
      65: "M",
      70: "L",
      75: "L",
      80: "",
    },
    "165-170": {
      45: "S",
      50: "M",
      55: "M",
      60: "M",
      65: "M",
      70: "L",
      75: "XL",
      80: "XL",
    },
    "170-175": {
      45: "",
      50: "M",
      55: "M",
      60: "M",
      65: "L",
      70: "L",
      75: "XL",
      80: "XL",
    },
    "175-180": {
      45: "",
      50: "",
      55: "",
      60: "L",
      65: "L",
      70: "XL",
      75: "XL",
      80: "",
    },
  },
  "CHV-F": [
    {
      "fr_de_eu": "35",
      "it": "34",
      "uk": "2.5",
      "us": "4",
      "foot_length": "22,4 cm",
    },
    {
      "fr_de_eu": "35,5",
      "it": "34,5",
      "uk": "3",
      "us": "4.5",
      "foot_length": "22,7 cm",
    },
    {
      "fr_de_eu": "36",
      "it": "35",
      "uk": "3.5",
      "us": "5",
      "foot_length": "23 cm",
    },
    {
      "fr_de_eu": "36,5",
      "it": "35,5",
      "uk": "4",
      "us": "5.5",
      "foot_length": "23,4 cm",
    },
    {
      "fr_de_eu": "37",
      "it": "36",
      "uk": "4",
      "us": "6",
      "foot_length": "23,7 cm",
    },
    {
      "fr_de_eu": "37,5",
      "it": "36,5",
      "uk": "4.5",
      "us": "6.5",
      "foot_length": "24 cm",
    },
    {
      "fr_de_eu": "38",
      "it": "37",
      "uk": "5",
      "us": "7",
      "foot_length": "24,4 cm",
    },
    {
      "fr_de_eu": "38,5",
      "it": "37,5",
      "uk": "5.5",
      "us": "7.5",
      "foot_length": "24,7 cm",
    },
    {
      "fr_de_eu": "39",
      "it": "38",
      "uk": "5.5",
      "us": "8",
      "foot_length": "25 cm",
    },
    {
      "fr_de_eu": "39,5",
      "it": "38,5",
      "uk": "6",
      "us": "8.5",
      "foot_length": "25,4 cm",
    },
    {
      "fr_de_eu": "40",
      "it": "39",
      "uk": "6.5",
      "us": "9",
      "foot_length": "25,7 cm",
    },
    {
      "fr_de_eu": "40,5",
      "it": "39,5",
      "uk": "7",
      "us": "9.5",
      "foot_length": "26 cm",
    },
    {
      "fr_de_eu": "41",
      "it": "40",
      "uk": "7.5",
      "us": "10",
      "foot_length": "26,4 cm",
    },
    {
      "fr_de_eu": "41,5",
      "it": "40,5",
      "uk": "7.5",
      "us": "10.5",
      "foot_length": "26,7 cm",
    },
    {
      "fr_de_eu": "42",
      "it": "41",
      "uk": "8",
      "us": "11",
      "foot_length": "27 cm",
    },
    {
      "fr_de_eu": "42,5",
      "it": "41,5",
      "uk": "8.5",
      "us": "11.5",
      "foot_length": "27,4 cm",
    },
    {
      "fr_de_eu": "43",
      "it": "42",
      "uk": "9",
      "us": "12",
      "foot_length": "27,7 cm",
    },
  ],
  "CHV-H": [
    {
      "fr_de_eu": "39",
      "it": "38",
      "uk": "5.5",
      "us": "6",
      "foot_length": "25 cm",
    },
    {
      "fr_de_eu": "39,5",
      "it": "38,5",
      "uk": "6",
      "us": "6.5",
      "foot_length": "25,4 cm",
    },
    {
      "fr_de_eu": "40",
      "it": "39",
      "uk": "6.5",
      "us": "7",
      "foot_length": "25,7 cm",
    },
    {
      "fr_de_eu": "40,5",
      "it": "39,5",
      "uk": "7",
      "us": "7.5",
      "foot_length": "26 cm",
    },
    {
      "fr_de_eu": "41",
      "it": "40",
      "uk": "7.5",
      "us": "8",
      "foot_length": "26,4 cm",
    },
    {
      "fr_de_eu": "41,5",
      "it": "40,5",
      "uk": "8",
      "us": "8.5",
      "foot_length": "26,7 cm",
    },
    {
      "fr_de_eu": "42",
      "it": "41",
      "uk": "8.5",
      "us": "9",
      "foot_length": "27 cm",
    },
    {
      "fr_de_eu": "42,5",
      "it": "41,5",
      "uk": "9",
      "us": "9.5",
      "foot_length": "27,4 cm",
    },
    {
      "fr_de_eu": "43",
      "it": "42",
      "uk": "9.5",
      "us": "10",
      "foot_length": "27,7 cm",
    },
    {
      "fr_de_eu": "43,5",
      "it": "42,5",
      "uk": "10",
      "us": "10.5",
      "foot_length": "28 cm",
    },
    {
      "fr_de_eu": "44",
      "it": "43",
      "uk": "10.5",
      "us": "11",
      "foot_length": "28,4 cm",
    },
    {
      "fr_de_eu": "44,5",
      "it": "43,5",
      "uk": "11",
      "us": "11.5",
      "foot_length": "28,7 cm",
    },
    {
      "fr_de_eu": "45",
      "it": "44",
      "uk": "11.5",
      "us": "12",
      "foot_length": "29 cm",
    },
    {
      "fr_de_eu": "45,5",
      "it": "44,5",
      "uk": "12",
      "us": "12.5",
      "foot_length": "29,4 cm",
    },
    {
      "fr_de_eu": "46",
      "it": "45",
      "uk": "12.5",
      "us": "13",
      "foot_length": "29,7 cm",
    },
  ],
  "CLA-CE": {
    
      "100-105": {
        10: "4_years",
        15: "4_years",
        20: "",
        25: "",
        30: "",
        35: "",
        40: ""
      },
      "105-110": {
        10: "4_years",
        15: "6_years",
        20: "6_years",
        25: "",
        30: "",
        35: "",
        40: ""
      },
      "110-115": {
        10: "6_years",
        15: "6_years",
        20: "6_years",
        25: "",
        30: "",
        35: "",
        40: ""
      },
      "115-120": {
        10: "6_years",
        15: "6_years",
        20: "8_years",
        25: "8_years",
        30: "",
        35: "",
        40: ""
      },
      "120-125": {
        10: "",
        15: "8_years",
        20: "8_years",
        25: "8_years",
        30: "",
        35: "",
        40: ""
      },
      "125-130": {
        10: "",
        15: "8_years",
        20: "8_years",
        25: "10_years",
        30: "10_years",
        35: "",
        40: ""
      },
      "130-135": {
        10: "",
        15: "",
        20: "10_years",
        25: "10_years",
        30: "10_years",
        35: "",
        40: ""
      },
      "135-140": {
        10: "",
        15: "",
        20: "10_years",
        25: "10_years",
        30: "12_years",
        35: "12_years",
        40: ""
      },
      "140-145": {
        10: "",
        15: "",
        20: "",
        25: "12_years",
        30: "12_years",
        35: "12_years",
        40: ""
      },
      "145-150": {
        10: "",
        15: "",
        20: "",
        25: "12_years",
        30: "12_years",
        35: "14_years",
        40: "14_years"
      },
      "150-155": {
        10: "",
        15: "",
        20: "",
        25: "14_years",
        30: "14_years",
        35: "14_years",
        40: "14_years"
      },
      "155-160": {
        10: "",
        15: "",
        20: "",
        25: "14_years",
        30: "14_years",
        35: "14_years",
        40: ""
      }
    
  },
  "CLA-DP": [
    {
      "fr_de_eu": "25",
      "it": "24",
      "uk": "C8",
      "us_woman": "K9",
      "us_man": "K9",
    },
    {
      "fr_de_eu": "25,5",
      "it": "24,5",
      "uk": "C8 1/4",
      "us_woman": "K9 1/4",
      "us_man": "K9 1/4",
    },
    {
      "fr_de_eu": "26",
      "it": "25",
      "uk": "C8 1/2",
      "us_woman": "K9.5",
      "us_man": "K9.5",
    },
    {
      "fr_de_eu": "26,5",
      "it": "25,5",
      "uk": "C8 3/4",
      "us_woman": "K9 3/4",
      "us_man": "K9 3/4",
    },
    {
      "fr_de_eu": "27",
      "it": "26",
      "uk": "C9",
      "us_woman": "K10",
      "us_man": "K10",
    },
    {
      "fr_de_eu": "27,5",
      "it": "26,5",
      "uk": "C9 1/2",
      "us_woman": "K10.5",
      "us_man": "K10.5",
    },
    {
      "fr_de_eu": "28",
      "it": "27",
      "uk": "C10",
      "us_woman": "K11",
      "us_man": "K11",
    },
    {
      "fr_de_eu": "28,5",
      "it": "27,5",
      "uk": "C10.5",
      "us_woman": "K11.5",
      "us_man": "K11.5",
    },
    {
      "fr_de_eu": "29",
      "it": "28",
      "uk": "C11",
      "us_woman": "K12",
      "us_man": "K12",
    },
    {
      "fr_de_eu": "29,5",
      "it": "28,5",
      "uk": "C11 1/3",
      "us_woman": "K12 1/3",
      "us_man": "K12 1/3",
    },
    {
      "fr_de_eu": "30",
      "it": "29",
      "uk": "C11 2/3",
      "us_woman": "K12.5",
      "us_man": "K12.5",
    },
    {
      "fr_de_eu": "30,5",
      "it": "29,5",
      "uk": "C12",
      "us_woman": "K13",
      "us_man": "K13",
    },
    {
      "fr_de_eu": "31",
      "it": "30",
      "uk": "C12 1/3",
      "us_woman": "K13 1/3",
      "us_man": "K13 1/3",
    },
    {
      "fr_de_eu": "31,5",
      "it": "30,5",
      "uk": "C12 2/3",
      "us_woman": "K13 2/3",
      "us_man": "K13 2/3",
    },
    {
      "fr_de_eu": "32",
      "it": "31",
      "uk": "C13",
      "us_woman": "1",
      "us_man": "1",
    },
    {
      "fr_de_eu": "32,5",
      "it": "31,5",
      "uk": "0",
      "us_woman": "1.5",
      "us_man": "1.5",
    },
    {
      "fr_de_eu": "33",
      "it": "32",
      "uk": "1",
      "us_woman": "2",
      "us_man": "2",
    },
    {
      "fr_de_eu": "33,5",
      "it": "32,5",
      "uk": "1.5",
      "us_woman": "2.5",
      "us_man": "2.5",
    },
    {
      "fr_de_eu": "34",
      "it": "33",
      "uk": "2",
      "us_woman": "3",
      "us_man": "3",
    },
    {
      "fr_de_eu": "34,5",
      "it": "33,5",
      "uk": "2.25",
      "us_woman": "3.5",
      "us_man": "3.5",
    },
    {
      "fr_de_eu": "35",
      "it": "34",
      "uk": "2.5",
      "us_woman": "4",
      "us_man": "4",
    },
    {
      "fr_de_eu": "35,5",
      "it": "34,5",
      "uk": "3",
      "us_woman": "4.5",
      "us_man": "-",
    },
    {
      "fr_de_eu": "36",
      "it": "35",
      "uk": "3.5",
      "us_woman": "5",
      "us_man": "-",
    },
    {
      "fr_de_eu": "36,5",
      "it": "35,5",
      "uk": "4",
      "us_woman": "5.5",
      "us_man": "-",
    },
    {
      "fr_de_eu": "37",
      "it": "36",
      "uk": "4.5",
      "us_woman": "6",
      "us_man": "-",
    },
    {
      "fr_de_eu": "37,5",
      "it": "36,5",
      "uk": "4.75",
      "us_woman": "6.5",
      "us_man": "-",
    },
    {
      "fr_de_eu": "38",
      "it": "37",
      "uk": "5",
      "us_woman": "7",
      "us_man": "-",
    },
    {
      "fr_de_eu": "38,5",
      "it": "37,5",
      "uk": "5.5",
      "us_woman": "7.5",
      "us_man": "-",
    },
    {
      "fr_de_eu": "39",
      "it": "38",
      "uk": "5.5",
      "us_woman": "8",
      "us_man": "6",
    },
    {
      "fr_de_eu": "39,5",
      "it": "38,5",
      "uk": "6",
      "us_woman": "8.5",
      "us_man": "6.5",
    },
    {
      "fr_de_eu": "40",
      "it": "39",
      "uk": "6.5",
      "us_woman": "9",
      "us_man": "7",
    },
    {
      "fr_de_eu": "40,5",
      "it": "39,5",
      "uk": "6.75",
      "us_woman": "9.5",
      "us_man": "7.5",
    },
    {
      "fr_de_eu": "41",
      "it": "40",
      "uk": "7",
      "us_woman": "10",
      "us_man": "8",
    },
    {
      "fr_de_eu": "41,5",
      "it": "40,5",
      "uk": "7.5",
      "us_woman": "10.5",
      "us_man": "8.5",
    },
    {
      "fr_de_eu": "42",
      "it": "41",
      "uk": "8",
      "us_woman": "11",
      "us_man": "9",
    },
    {
      "fr_de_eu": "42,5",
      "it": "41,5",
      "uk": "8.5",
      "us_woman": "11.5",
      "us_man": "9.5",
    },
    {
      "fr_de_eu": "43",
      "it": "42",
      "uk": "9",
      "us_woman": "12",
      "us_man": "10",
    },
    {
      "fr_de_eu": "43,5",
      "it": "42,5",
      "uk": "9.5",
      "us_woman": "12.5",
      "us_man": "10.5",
    },
    {
      "fr_de_eu": "44",
      "it": "43",
      "uk": "9.75",
      "us_woman": "13",
      "us_man": "11",
    },
    {
      "fr_de_eu": "44,5",
      "it": "43,5",
      "uk": "10",
      "us_woman": "-",
      "us_man": "11.5",
    },
    {
      "fr_de_eu": "45",
      "it": "44",
      "uk": "10.25",
      "us_woman": "-",
      "us_man": "12",
    },
    {
      "fr_de_eu": "45,5",
      "it": "44,5",
      "uk": "10.5",
      "us_woman": "-",
      "us_man": "12.5",
    },
    {
      "fr_de_eu": "46",
      "it": "45",
      "uk": "11",
      "us_woman": "-",
      "us_man": "13",
    },
  ],
  "CLA-P": [
    {
      "fr_eu_de": "34",
      "it": "33",
      "uk": "2",
      "us_woman": "3",
      "us_man": "-",
    },
    {
      "fr_eu_de": "34,5",
      "it": "33,5",
      "uk": "2.5",
      "us_woman": "3.5",
      "us_man": "-",
    },
    {
      "fr_eu_de": "35",
      "it": "34",
      "uk": "2.5",
      "us_woman": "4",
      "us_man": "-",
    },
    {
      "fr_eu_de": "35,5",
      "it": "34,5",
      "uk": "3",
      "us_woman": "4.5",
      "us_man": "-",
    },
    {
      "fr_eu_de": "36",
      "it": "35",
      "uk": "3.5",
      "us_woman": "5",
      "us_man": "-",
    },
    {
      "fr_eu_de": "36.5",
      "it": "35,5",
      "uk": "4",
      "us_woman": "5.5",
      "us_man": "-",
    },
    {
      "fr_eu_de": "37",
      "it": "36",
      "uk": "4.5",
      "us_woman": "6",
      "us_man": "-",
    },
    {
      "fr_eu_de": "37,5",
      "it": "36,5",
      "uk": "5",
      "us_woman": "6.5",
      "us_man": "-",
    },
    {
      "fr_eu_de": "38",
      "it": "37",
      "uk": "5",
      "us_woman": "7",
      "us_man": "-",
    },
    {
      "fr_eu_de": "38,5",
      "it": "37,5",
      "uk": "5.5",
      "us_woman": "7.5",
      "us_man": "-",
    },
    {
      "fr_eu_de": "39",
      "it": "38",
      "uk": "5.5",
      "us_woman": "8",
      "us_man": "6",
    },
    {
      "fr_eu_de": "39,5",
      "it": "38,5",
      "uk": "6",
      "us_woman": "8.5",
      "us_man": "6.5",
    },
    {
      "fr_eu_de": "40",
      "it": "39",
      "uk": "6.5",
      "us_woman": "9",
      "us_man": "7",
    },
    {
      "fr_eu_de": "40,5",
      "it": "39,5",
      "uk": "6.5",
      "us_woman": "9.5",
      "us_man": "7.5",
    },
    {
      "fr_eu_de": "41",
      "it": "40",
      "uk": "7",
      "us_woman": "10",
      "us_man": "8",
    },
    {
      "fr_eu_de": "41,5",
      "it": "40,5",
      "uk": "7.5",
      "us_woman": "10.5",
      "us_man": "8.5",
    },
    {
      "fr_eu_de": "42",
      "it": "41",
      "uk": "8",
      "us_woman": "11",
      "us_man": "9",
    },
  ],
  "ATH-F": [
    {
      "fr_eu": "36",
      "de": "34",
      "it": "40",
      "uk": "8",
      "us": "4",
      "repetto": "XS",
    },
    {
      "fr_eu": "38",
      "de": "36",
      "it": "42",
      "uk": "10",
      "us": "6",
      "repetto": "S",
    },
    {
      "fr_eu": "40",
      "de": "38",
      "it": "44",
      "uk": "12",
      "us": "8",
      "repetto": "M",
    },
    {
      "fr_eu": "42",
      "de": "40",
      "it": "46",
      "uk": "14",
      "us": "10",
      "repetto": "L",
    },
    {
      "fr_eu": "44",
      "de": "42",
      "it": "48",
      "uk": "16",
      "us": "12",
      "repetto": "XL",
    },
  ],
  "CLA-VET": [
    {
      "fr_eu": "36",
      "de": "34",
      "it": "40",
      "uk": "8",
      "us": "4",
      "height": "162",
      "chest": "82",
      "waist": "62",
      "hips": "86",
      "inside_leg": "74",
      "repetto": "XS",
    },
    {
      "fr_eu": "38",
      "de": "36",
      "it": "42",
      "uk": "10",
      "us": "6",
      "height": "166",
      "chest": "86",
      "waist": "65",
      "hips": "90",
      "inside_leg": "76",
      "repetto": "S",
    },
    {
      "fr_eu": "40",
      "de": "38",
      "it": "44",
      "uk": "12",
      "us": "8",
      "height": "170",
      "chest": "90",
      "waist": "69",
      "hips": "94",
      "inside_leg": "78",
      "repetto": "M",
    },
    {
      "fr_eu": "42",
      "de": "40",
      "it": "46",
      "uk": "14",
      "us": "10",
      "height": "174",
      "chest": "94",
      "waist": "73",
      "hips": "98",
      "inside_leg": "80",
      "repetto": "L",
    },
    {
      "fr_eu": "44",
      "de": "42",
      "it": "48",
      "uk": "16",
      "us": "12",
      "height": "178",
      "chest": "98",
      "waist": "77",
      "hips": "103",
      "inside_leg": "82",
      "repetto": "XL",
    },
  ],
};